import { LOG_LEVEL_DEBUG } from '../constants/Constants';
import { ILoggerDetails } from '../types/types';

/**
 * This function will accommodate the fact that we may have to log server-side or client-side.
 * @param logger - logger to use (e.g. `console` object or an instance of a server-side logger, like `pino`, `loglevel` etc.)
 * @param message
 * @param messageLevel - the log level to use for logging (if you select 'debug', it will log all messages, otherwise only 'info' and above).
 */
export const LogMsg = (logger?: ILoggerDetails | null | undefined, message?: string, messageLevel: string = 'info') => {
  if (!logger || !message) {
    return;
  }

  message = `${new Date().toUTCString()} :: @emarketer/auth :: ${message}`;

  if (logger.loggerInstance === console) {
    switch (messageLevel) {
      case 'info':
        console.log(message);
        break;
      case 'warn':
        console.warn(message);
        break;
      case 'error':
        console.error(message);
        break;
      case 'debug':
        console.debug(message);
        break;
      default:
        console.log(message);
    }
  } else if (typeof logger?.loggerInstance.info === 'function') {
    switch (messageLevel) {
      case 'info':
        logger.loggerInstance.info(message);
        break;
      case 'warn':
        logger.loggerInstance.warn(message);
        break;
      case 'error':
        logger.loggerInstance.error(message);
        break;
      case 'debug':
        logger.loggerInstance.debug(message);
        break;
      default:
        logger.loggerInstance.info(message);
    }
  }
};

/**
 * This will only log if logger.logLevel is set to "debug".
 * @param logger - Logger instance (for back-end) or `console` instance (for front-end)
 * @param message - well, this one is self-explanatory :)
 * @returns
 */
export function LogDebug(logger?: ILoggerDetails, message?: string) {
  if (!logger || !message) {
    return;
  }

  // only log "debug" messages if the logger instance's logLevel is set to "debug"
  if (logger.logLevel !== LOG_LEVEL_DEBUG) {
    return;
  }

  LogMsg(logger, message);
}
